module.exports = __webpack_public_path__ + "img/fines-ua.89c5fdc4.svg";